import * as React from 'react';
import * as _ from 'underscore';

import { SiteRoleFilterHelper } from '../../../ts/helpers/SiteRoleFilterHelper';
import { ServerUserDefinition } from '../../../ts/models/ContentDefinitions';
import { ServerUsers } from '../../../ts/resources/ServerUsers';
import { SiteRoleOptionsResource } from '../../../ts/resources/SiteRoleOptions';
import { SiteRolesResource } from '../../../ts/resources/SiteRoles';
import { IStringValuedFilterClause } from '../../../ts/ServerApi/types/IFilterClause';
import { ISelectFilterDefinition } from '../../../ts/services/FilterPanelService';
import { ServiceLocator } from '../../ServiceLocator';
import { AdvancedFilterPanel, AdvancedFilterPanelProps, AdvancedFilterPanelScope } from './AdvancedFilterPanel';

export interface ServerUsersAdvancedFilterPanelProps extends AdvancedFilterPanelProps {}

export class ServerUsersAdvancedFilterPanel extends React.Component<ServerUsersAdvancedFilterPanelProps> {

  private maxSiteRoleFilterDefinition: ISelectFilterDefinition<string>;
  private users: ServerUsers = undefined;
  private siteRoles: SiteRolesResource = undefined;
  private siteRoleOptionsResource: SiteRoleOptionsResource = undefined;

  public constructor(props: ServerUsersAdvancedFilterPanelProps) {
    super(props);
    this.users = ServiceLocator.get('ServerUsers');
    this.siteRoles = ServiceLocator.get('SiteRoles');
    this.siteRoleOptionsResource = ServiceLocator.get('SiteRoleOptionsResource');
  }

  public render() {
    return <AdvancedFilterPanel {...{...this.props, scopeReference: this.scopeRef}} />;
  }

  public componentDidMount() {
    this.updateSiteRoleCounts();
  }

  public componentDidUpdate(prevProps: ServerUsersAdvancedFilterPanelProps) {
    if (this.searchTerm(this.props) !== this.searchTerm(prevProps)) {
      this.updateSiteRoleCounts();
    }
  }

  private updateSiteRoleCounts = async () => {
    let query = ServerUserDefinition.getBasicQuery();
    if (this.searchTerm(this.props)) {
      query = query.addFilter(this.props.mixedContentFilterMap.search);
    }
    const userCountsByRole = await this.users.getUserCountsByMaxSiteRole(query);
    this.maxSiteRoleFilterDefinition.options =
        SiteRoleFilterHelper.siteRoleOptions(this.siteRoles.optionsForCurrentUser(), this.siteRoleOptionsResource, userCountsByRole);
  }

  private scopeRef = (scope: AdvancedFilterPanelScope) => {
    this.maxSiteRoleFilterDefinition = scope.filterDefinitions[0] as ISelectFilterDefinition<string>;
  }

  private searchTerm = (props: ServerUsersAdvancedFilterPanelProps) => {
    return (props.mixedContentFilterMap.search
      && (props.mixedContentFilterMap.search as IStringValuedFilterClause).value)
      || '';
  }
}
